
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import AreaHero from '../components/AreaHero';
import AreaServices from '../components/AreaServices';
import AreaTestimonials from '../components/AreaTestimonials';
import AreaCTA from '../components/AreaCTA';
import { useSEO, generateAreaPageSchema, generateBreadcrumbSchema } from '../../../utils/seo';

export default function GerrardsCrossPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Painters & Decorators Gerrards Cross Buckinghamshire | Brushour',
    description: 'Premium painting and decorating services in Gerrards Cross, Buckinghamshire. Covering Gerrards Cross Town, Fulmer, and Chalfont St Peter. Fully insured, free quotes available.',
    keywords: 'painters Gerrards Cross, decorators Gerrards Cross Buckinghamshire, painting services Gerrards Cross, Buckinghamshire painters decorators, decorating Chalfont St Peter',
    canonical: `${SITE_URL}/areas/gerrards-cross`,
    schema: [
      generateAreaPageSchema('Gerrards Cross', 'Buckinghamshire', 'gerrards-cross', 51.5833, -0.5583, 'SL9'),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Areas', url: `${SITE_URL}/areas` },
        { name: 'Gerrards Cross', url: `${SITE_URL}/areas/gerrards-cross` },
      ]),
    ],
  });

  const areaData = {
    name: 'Gerrards Cross',
    region: 'Buckinghamshire',
    description: 'Premium painting and decorating services in Gerrards Cross. We provide exceptional craftsmanship and attention to detail for discerning clients, offering a full range of painting and decorating services throughout Gerrards Cross.',
    heroImage: 'https://public.readdy.ai/ai/img_res/78ffddf574d011f454b841e4b78b941b.jpg',
    serviceAreas: ['Gerrards Cross Town', 'Fulmer', 'Hedgerley', 'Chalfont St Peter'],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AreaHero data={areaData} />
      <AreaServices area="Gerrards Cross" />
      <AreaTestimonials area="Gerrards Cross" />
      <AreaCTA area="Gerrards Cross" />
      <Footer />
    </div>
  );
}
